'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _moment = require('moment/moment');
var _moment2 = _interopRequireDefault(_moment);
var _reactDatepicker = require('react-datepicker');
var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
var _TextInput = require('../TextInput/TextInput');
var _TextInput2 = _interopRequireDefault(_TextInput);
require('react-datepicker/dist/react-datepicker.css');
require('./datepicker.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Component that outputs a (partial) date in ISO format, but is able to render
 * in a more user friendly format. It will also parse most common date input formats.
 */
var DateInput = function (_Component) {
  _inherits(DateInput, _Component);
  function DateInput(props) {
    _classCallCheck(this, DateInput);
    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
    _initialiseProps.call(_this);
    var text = props.value;
    if (text && text.length === 4) {
      text = (0, _moment2.default)(text).format(props.yearFormat);
    } else if (text && text.length === 7) {
      text = (0, _moment2.default)(text).format(props.yearMonthFormat);
    } else if (text) {
      text = (0, _moment2.default)(text).format(props.dateFormat);
    }
    _this.state = {
      text: text
    };
    return _this;
  }
  _createClass(DateInput, [{
    key: 'notifyOnChange',
    value: function notifyOnChange(value) {
      var onChange = this.props.onChange;
      if (onChange) {
        onChange({
          type: 'change',
          target: {
            value: value
          }
        });
      }
    }
  }]);
  return DateInput;
}(_react.Component);
var _initialiseProps = function _initialiseProps() {
  var _this2 = this;
  this.componentDidUpdate = function (prevProps) {
    var _props = _this2.props,
      value = _props.value,
      yearFormat = _props.yearFormat,
      yearMonthFormat = _props.yearMonthFormat,
      dateFormat = _props.dateFormat,
      formats = _props.formats;
    var text = _this2.state.text;
    if (value !== prevProps.value) {
      if (value) {
        var newText = value;
        if (newText && newText.length === 4) {
          newText = (0, _moment2.default)(newText).format(yearFormat);
        } else if (newText && newText.length === 7) {
          newText = (0, _moment2.default)(newText).format(yearMonthFormat);
        } else if (newText) {
          newText = (0, _moment2.default)(newText).format(dateFormat);
        }
        if (!text || !(0, _moment2.default)(text, formats, true).isSame((0, _moment2.default)(newText, formats, true), 'date')) {
          _this2.setState({
            text: newText
          });
        }
      } else {
        _this2.setState({
          text: ''
        });
      }
    }
  };
  this.onChange = function (event) {
    var _props2 = _this2.props,
      formats = _props2.formats,
      value = _props2.value,
      onChange = _props2.onChange;
    var text = event.target.value;
    text = text ? text.replace(/[^\/\-0-9]/g, '') : null;
    _this2.setState({
      text: text
    });
    if (onChange) {
      var parsedDate = text ? (0, _moment2.default)(text, formats, true) : null;
      if (parsedDate && parsedDate.isValid()) {
        var mask = _this2.getMask(parsedDate.parsingFlags().parsedDateParts.length);
        var newValue = parsedDate.format(mask);
        if (newValue !== value) {
          onChange(newValue);
        }
      } else {
        if (value) {
          onChange(null);
        }
      }
    }
  };
  this.onDateChange = function (date) {
    _this2.props.onChange(date ? date.format('YYYY-MM-DD') : null);
  };
  this.getMask = function (nbParts) {
    switch (nbParts) {
      case 0:
        return null;
      case 1:
        return 'YYYY';
      case 2:
        return 'YYYY-MM';
      default:
        return 'YYYY-MM-DD';
    }
  };
  this.render = function () {
    var _props3 = _this2.props,
      formats = _props3.formats,
      dateFormat = _props3.dateFormat,
      yearFormat = _props3.yearFormat,
      yearMonthFormat = _props3.yearMonthFormat,
      value = _props3.value,
      onChange = _props3.onChange,
      todayButton = _props3.todayButton,
      props = _objectWithoutProperties(_props3, ['formats', 'dateFormat', 'yearFormat', 'yearMonthFormat', 'value', 'onChange', 'todayButton']);
    var selected = value ? (0, _moment2.default)(value, formats, true) : null;
    return _react2.default.createElement(_reactDatepicker2.default, {
      customInput: _react2.default.createElement(_TextInput2.default, _extends({}, props, {
        iconType: 'calendar'
      })),
      selected: selected,
      value: _this2.state.text,
      onChange: _this2.onDateChange,
      onChangeRaw: _this2.onChange,
      todayButton: todayButton,
      disabledKeyboardNavigation: true
    });
  };
};
DateInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Current date value */
  value: _propTypes2.default.string,
  /** Callback fired with an event when the value changes. The value of the target of this event will be a (partial) ISO date */
  onChange: _propTypes2.default.func,
  /** Supported formats for parsing. */
  formats: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /** Format to use when rendering a full date (date, month and year). */
  dateFormat: _propTypes2.default.string,
  /** Format to use when rendering a partial date (month and year). */
  yearMonthFormat: _propTypes2.default.string,
  /** Format to use when rendering a partial date (year only). */
  yearFormat: _propTypes2.default.string,
  /** Text to render on today button */
  todayButton: _propTypes2.default.string
} : {};
DateInput.defaultProps = {
  formats: ['YYYY-MM-DD', 'D/M/YYYY', 'M/YYYY', 'YYYY', 'YYYY-M'],
  dateFormat: 'DD/MM/YYYY',
  yearMonthFormat: 'MM/YYYY',
  yearFormat: 'YYYY'
};
exports.default = DateInput;